import { render, staticRenderFns } from "./payMerchant.vue?vue&type=template&id=615d1c64&scoped=true"
import script from "./payMerchant.vue?vue&type=script&lang=js"
export * from "./payMerchant.vue?vue&type=script&lang=js"
import style0 from "./payMerchant.vue?vue&type=style&index=0&id=615d1c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d1c64",
  null
  
)

export default component.exports